import BaseModel from './base';

export const SUBSCRIPTION_STATUS = {
	ACTIVE: 'active',
	PENDING: 'pending',
	TRIALING: 'trialing',
	CANCELED: 'canceled',
	PAST_DUE: 'past_due',
	EXPIRED: 'expired'
};

class Subscription extends BaseModel {
	subscribe({
		priceId,
		mainPriceId,
		currency,
		handlerData = {},
		onlyAttachAndSwitch = false,
		originalAmount
	}) {
		const body = {
			priceId,
			handlerData,
			onlyAttachAndSwitch,
			originalAmount
		};

		if (currency) {
			body.currency = currency;
		}

		if (mainPriceId) {
			body.mainPriceId = mainPriceId;
		}

		return this.post('/', {
			body
		});
	}

	/**
	 * Cancel subscription at the end of current period.
	 */
	cancelSubscription() {
		return this.post('/cancel');
	}

	/**
	 * Rollback the cancellation if the current period is not finished.
	 */
	cancelRollback() {
		return this.post('/cancel-rollback');
	}

	cancelByEmail(body) {
		return this.post('/cancel-by-email', { body });
	}
}

export default new Subscription('/subscription');
